import { theme } from "@tm/utility/global";
import styled, { keyframes } from "styled-components";

export const titleStyle = {
  color: theme.blackText,
  fontSize: "22px",
  lineHeight: "26px",
  fontWeight: 900,
};

export const descriptionStyle = {
  color: theme.blackText,
  fontSize: "16px",
  lineHeight: "20px",
  fontWeight: 400,
};

export const PopupBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 28px 24px 24px;
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideUp = keyframes`
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const SheetBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: ${theme.lightBlack};
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  animation: ${fadeIn} 0.2s ease-out;
`;

export const SheetPanel = styled.div`
  position: relative;
  background: ${theme.whiteText};
  border-radius: 16px 16px 0 0;
  width: 100%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: ${slideUp} 0.25s ease-out forwards;
`;

export const SheetBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 16px calc(20px + env(safe-area-inset-bottom));
`;

export const PopupHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-right: 24px;
`;

export const PopupActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: ${theme.greyText8};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  z-index: 5;
`;

export const Spinner = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 3px solid ${theme.gainsBoro};
  border-top-color: ${theme.blueText};
  animation: ${spin} 0.8s linear infinite;
`;
